export enum ProviderStatus {
  new = 'new',
  user_reviewed = 'user_reviewed',
  providerNotValid = 'provider_not_valid',
  notAReferralSpecialty = 'not_a_referral_specialty',
  needsUserReview = 'needs_user_review',
  neverUserReviewed = 'never_user_reviewed',
}
